import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@/stores/auth-store";
import { ApiError } from "./api-client";
import { handleMutationError } from "./mutation-error-handler";
import { handleSessionExpired } from "./session-check";

export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error) => {
			if (error instanceof ApiError && error.status === 401) {
				useAuthStore.getState().setAuthenticated(false);
				handleSessionExpired();
			}
		},
	}),
	mutationCache: new MutationCache({
		onError: (error, variables, context, mutation) => {
			if (error instanceof ApiError && error.status === 401) {
				useAuthStore.getState().setAuthenticated(false);
				handleSessionExpired();
			}
			handleMutationError(error, variables, context, mutation);
		},
	}),
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			gcTime: 1000 * 60 * 30,
			retry: (failureCount, error) => {
				if (error instanceof ApiError) {
					if ([401, 403, 404, 422].includes(error.status)) {
						return false;
					}
				}
				return failureCount < 2;
			},
			refetchOnWindowFocus: false,
		},
		mutations: {
			retry: false,
		},
	},
});
